var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_203_201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13.2V4.49824C20 4.30728 19.921 4.12415 19.7804 3.98911L15.8446 0.210888C15.704 0.075852 15.5132 0 15.3144 0H0.75C0.335787 0 0 0.322356 0 0.72V23.28C0 23.6777 0.335787 24 0.75 24H12.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.2C18 14.3046 18.8954 15.2 20 15.2C21.1046 15.2 22 14.3046 22 13.2H18ZM19.7804 3.98911L21.1656 2.54652L21.1654 2.54632L19.7804 3.98911ZM15.8446 0.210888L14.4594 1.65348L14.4596 1.65368L15.8446 0.210888ZM12.5 26C13.6046 26 14.5 25.1046 14.5 24C14.5 22.8954 13.6046 22 12.5 22V26ZM22 13.2V4.49824H18V13.2H22ZM22 4.49824C22 3.75002 21.6897 3.04976 21.1656 2.54652L18.3951 5.4317C18.1523 5.19853 18 4.86454 18 4.49824H22ZM21.1654 2.54632L17.2297 -1.2319L14.4596 1.65368L18.3953 5.4319L21.1654 2.54632ZM17.2299 -1.2317C16.7084 -1.73242 16.018 -2 15.3144 -2V2C15.0085 2 14.6996 1.88412 14.4594 1.65348L17.2299 -1.2317ZM15.3144 -2H0.75V2H15.3144V-2ZM0.75 -2C-0.691049 -2 -2 -0.858376 -2 0.72H2C2 1.50309 1.36262 2 0.75 2V-2ZM-2 0.72V23.28H2V0.72H-2ZM-2 23.28C-2 24.8585 -0.690985 26 0.75 26V22C1.36256 22 2 22.4969 2 23.28H-2ZM0.75 26H12.5V22H0.75V26Z",
    fill: "#1CBFA2",
    mask: "url(#path-1-inside-1_203_201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_203_201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0.959961V4.94928C14 5.33809 14.3283 5.65328 14.7333 5.65328H18.8889"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.959961C16 -0.144609 15.1046 -1.04004 14 -1.04004C12.8954 -1.04004 12 -0.144609 12 0.959961H16ZM18.8889 7.65328C19.9934 7.65328 20.8889 6.75785 20.8889 5.65328C20.8889 4.54871 19.9934 3.65328 18.8889 3.65328V7.65328ZM12 0.959961V4.94928H16V0.959961H12ZM12 4.94928C12 6.51876 13.3014 7.65328 14.7333 7.65328V3.65328C15.3552 3.65328 16 4.15742 16 4.94928H12ZM14.7333 7.65328H18.8889V3.65328H14.7333V7.65328Z",
    fill: "#1CBFA2",
    mask: "url(#path-3-inside-2_203_201)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 18.8801H23M23 18.8801L19 15.3601M23 18.8801L19 22.4001",
    stroke: "#0389E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.621b97d1b7066898de2304887c59b074.svg";
export { ForwardRef as ReactComponent };